.card:hover {
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-primaryDark-7));
  cursor: pointer;
}

/* Clamp text to 2 lines with ellipsis */
.clamp2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
}
